/**
 * GraphQL fragments for DatoCMS queries
 * These fragments can be used across multiple queries to maintain consistency
 * and reduce duplication in our data fetching logic.
 */

export const TagFragment = /* GraphQL */ `
  fragment TagFragment on Tag {
    tag
    attributes
    content
  }
`

export const ResponsiveImage = /* GraphQL */ `
  fragment ResponsiveImage on ResponsiveImage {
    srcSet
    webpSrcSet
    sizes
    src
    width
    height
    aspectRatio
    alt
    title
    bgColor
    base64
  }
`

export const CallToAction = /* GraphQL */ `
  fragment CallToAction on CtaRecord {
    externalLink
    id
    recordLink {
      __typename
      ... on LocationRecord {
        _modelApiKey
        slug
      }
      ... on ProjectRecord {
        _modelApiKey
        slug
      }
      ... on PageRecord {
        _modelApiKey
        slug
      }
    }
    primary
    title
  }
`

export const Iframe = /* GraphQL */ `
  fragment Iframe on IframeRecord {
    title
    src
    width
    height
  }
`

export const Media = /* GraphQL */ `
  fragment Media on MediaBlockRecord {
    mediaBlockAssets {
      __typename
      title
      customData
      url
      width
      height
      alt
      mimeType
      title
      format
      responsiveImage {
        ...ResponsiveImage
      }
      video {
        duration
        framerate
        mp4Url(res: medium, exactRes: medium)
        thumbnailUrl
        streamingUrl
        muxPlaybackId
        muxAssetId
      }
    }
    layout
  }
`

export const Table = /* GraphQL */ `
  fragment Table on TableRecord {
    id
    caption
    table
  }
`

export const VideoExternal = /* GraphQL */ `
  fragment VideoExternal on VideoExternalRecord {
    video {
      url
      title
      thumbnailUrl
      height
      provider
      providerUid
      width
    }
  }
`

export const Video = /* GraphQL */ `
  fragment Video on VideoBlockRecord {
    thumbnail {
      alt
      url
      width
      height
      responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
        ...ResponsiveImage
      }
    }
    videoLoop {
      url
      title
      height
      width
    }
    video {
      url
      title
      height
      width
    }
  }
`
